var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._m(0),_c('div',{staticClass:"login-section"},[_c('div',{staticClass:"login"},[_c('StudentLogin')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-box"},[_c('span',{staticClass:"red-txt"},[_vm._v("系统提示：")]),_c('span',[_vm._v(" 本系统建议使用谷歌浏览器、360浏览器(极速模式)。如您的浏览器版本较低,建议做相应的升级。如登录后页面显示不全,请调整浏览器缩放比例到100%。 ")])])
}]

export { render, staticRenderFns }